export const colorsList = [
  { name: "red", hex: "#F50D5A", selected: false },
  { name: "orange", hex: "#FF865C", selected: false },
  { name: "yellow", hex: "#FFEA5C", selected: false },
  { name: "green", hex: "#00DA76", selected: false },
  { name: "blue", hex: "#0096CE", selected: false },
  { name: "violet", hex: "#800FFF", selected: false }
];